module.exports = __webpack_public_path__ + "media/src/images/olympiads/entrepreneurship-7cf2880f0009891285d7a329d6cf749d.svg";